import React, { Component } from 'react'

import NewsLetter from "./NewsLetter"
import About from "./About"
import FinancialFreedom from "./FinancialFreedom"
import GetStarted from './GetStarted'
import Testimonial from "./Testimonial"
import PaymentMethod from "./PaymentMethod"

import Layout from "../../components/Layout"
//Landing page styles

import "./css/landingpage2.css"
import "./css/landingpage3.css"
import "./css/landingpage4.css"
import "./css/landingpage5.css"

class LandingPage extends Component {
    render() {
        return (
            <Layout {...this.props}>
                <div className="landingpage">
                    <NewsLetter />
                    <About />
                    <FinancialFreedom />
                    <GetStarted />
                    <Testimonial />
                    <PaymentMethod />
                </div>
            </Layout>
        )
    }
}

export default LandingPage;